// Mock data for Ambarsariya Restaurant

// Swiggy online ordering link (Ambarsariya, Nandanvan, Nagpur)
export const SWIGGY_ORDER_URL = "https://www.swiggy.com/city/nagpur/ambarsariya-ayodhya-nagar-nandanvan-rest814042?utm_source=GooglePlaceOrder&utm_campaign=GoogleMap&is_retargeting=true&media_source=GooglePlaceOrder";

// Zomato online ordering link (Ambarsariya, Nagpur)
export const ZOMATO_ORDER_URL = "http://zoma.to/r/20896516";

// Press / media coverage of Ambarsariya
export const pressMentions = [
  {
    id: 1,
    name: "PNN Digital",
    logo: "https://pnn.digital/wp-content/uploads/2026/02/pnn@4x-8.png",
    title: "Experience the Authentic Taste of Amritsar at Ambarsariya in VR Nagpur",
    url: "https://pnn.digital/experience-the-authentic-taste-of-amritsar-at-ambarsariya-in-vr-nagpur/"
  },
  {
    id: 2,
    name: "Dailyhunt",
    logo: "https://upload.wikimedia.org/wikipedia/commons/f/fd/Daily_hunt.png",
    title: "Ambarsariya brings the iconic flavours of Amritsar to Nagpur",
    url: "https://m.dailyhunt.in/news/india/english/punjabbytes-epaper-dhb7faabc774324241990251ac4336f653/-newsid-dhb7faabc774324241990251ac4336f653_5a5402ce63a94bc78f2cf90c1a8f014b?sm=Y"
  }
];


export const restaurantInfo = {
  name: "Ambarsariya",
  tagline: "Authentic North Indian Vegetarian Cuisine",
  phone: "+918799997457",
  email: "info@ambarsariya.co.in",
  address: "VR Nagpur",
  franchiseContact: "+918799997457"
};

export const menuCategories = [
  {
    id: 1,
    name: "Tandoor Starters",
    description: "Freshly baked in traditional tandoor",
    items: [
      { name: "Tandoori Chaap", price: 200 },
      { name: "Amritsari Chaap", price: 262 },
      { name: "Tandoori Paneer Tikka", price: 290 },
      { name: "Amritsari Paneer Tikka", price: 310 }
    ]
  },
  {
    id: 2,
    name: "Mumbai Special",
    description: "Street food from the heart of Mumbai",
    items: [
      { name: "Pav Bhaji", price: 191 },
      { name: "Cheese Pav Bhaji", price: 214 },
      { name: "Vada Pav (2Pcs)", price: 114 },
      { name: "Bhel Puri", price: 114 },
      { name: "Mini Samosa Chaat (4 pc)", price: 153 }
    ]
  },
  {
    id: 3,
    name: "Dilli Ki Chaat",
    description: "Delhi's famous street delicacies",
    items: [
      { name: "Golgappe (6 pcs)", price: 71 },
      { name: "Dahi Mathri Chaat", price: 100 },
      { name: "Cheese Sev Puri (6 pcs)", price: 100 },
      { name: "Aloo Tikki Chaat", price: 153 },
      { name: "Chole Bhature", price: 248 }
    ]
  },
  {
    id: 4,
    name: "Tandoori Kulcha Combo",
    description: "All Kulchas served with Chole, Chutney, Amul Butter, and Onion",
    items: [
      { name: "Aloo Kulcha", withoutCheese: 200, withCheese: 230 },
      { name: "Aloo Pyaz Kulcha", withoutCheese: 210, withCheese: 240 },
      { name: "Aloo Lasuni Kulcha", withoutCheese: 220, withCheese: 250 },
      { name: "Aloo Paneer Kulcha", withoutCheese: 234, withCheese: 264 },
      { name: "Paneer Kulcha", withoutCheese: 243, withCheese: 273 },
      { name: "Paneer Pyaz Kulcha", withoutCheese: 243, withCheese: 273 },
      { name: "Lasuni Paneer Kulcha", withoutCheese: 253, withCheese: 283 },
      { name: "Spl Amritsari Kulcha", withoutCheese: 262, withCheese: 292 }
    ]
  },
  {
    id: 5,
    name: "Biryani",
    items: [
      { name: "Veg Dum Biryani", price: 280 },
      { name: "Paneer Veg Dum Biryani", price: 300 }
    ]
  },
  {
    id: 6,
    name: "Rice Bowls",
    items: [
      { name: "Dal Makhani", price: 262, description: "(Dal Makhani, Rice, Onion, Papad, Pickle)" },
      { name: "Shahi Paneer", price: 276, description: "(Shahi Paneer, Rice, Onion, Papad, Pickle)" },
      { name: "Punjabi Chole", price: 262, description: "(Punjabi Chole, Rice, Onion, Papad, Pickle)" }
    ]
  },
  {
    id: 7,
    name: "North Indian Combos",
    items: [
      { name: "Dal Makhani Combo", price: 305, description: "(Dal Makhani, Chutney, Paratha, Rice, Onion, Pickle & Papad)" },
      { name: "Shahi Paneer Combo", price: 315, description: "(Shahi Paneer, Laccha Paratha, Rice, Chutney, Onion, Pickle & Papad)" },
      { name: "Punjabi Chole Combo", price: 305, description: "(Punjabi Chole, Laccha Paratha, Rice, Chutney, Onion, Pickle & Papad)" },
      { name: "Mix Veg Combo", price: 305, description: "(Mix Veg Sabji, Laccha Paratha, Rice, Chutney, Onion, Pickle & Papad)" },
      { name: "Chur Chur Naan Thali", price: 353, description: "(2 Chur Chur Naan, Dal Makhani, Chole, Chutney & Onion & Pickle)" },
      { name: "Spl. Deluxe Thali", price: 377, description: "(Tandoori Roti/Naan/ Laccha Paratha, Rice, Dal, Paneer of the day, Chole, Papad, Chutney, Onion, Pickle, Lassi)" },
      { name: "Chole Bhature Combo", price: 305, description: "(Chole Bhature + Punjabi Lassi)" }
    ]
  },
  {
    id: 8,
    name: "Beverages",
    items: [
      { name: "Punjabi Lassi", price: 81 },
      { name: "Butter Milk", price: 62 },
      { name: "Mineral Water", price: "MRP" },
      { name: "Cold Drink", price: "MRP" }
    ]
  },
  {
    id: 9,
    name: "Extras",
    items: [
      { name: "Chur Chur Naan", price: 100 },
      { name: "Laccha Paratha", price: 62 },
      { name: "Raita", price: 38 },
      { name: "Chole", price: 38 },
      { name: "Extra Pav (2pcs)", price: 38 },
      { name: "Bhatura (1 pc)", price: 114 }
    ]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_6155f013-7394-403e-8ef1-e61234cc182e/artifacts/3e7876s6_Chole_Bhature_edit.png",
    alt: "Fluffy Chole Bhature"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1769019401093-38f564d6408a",
    alt: "Street Food Chaat"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1760263051323-fcd7da7040b0",
    alt: "Golgappe"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_6155f013-7394-403e-8ef1-e61234cc182e/artifacts/p89jj2y3_Aloo%20Tikki%20Chaat.png",
    alt: "Aloo Tikki Chaat"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_6155f013-7394-403e-8ef1-e61234cc182e/artifacts/lgzmnul9_Veg%20Biryani.jpg",
    alt: "Veg Biryani in Handi"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_6155f013-7394-403e-8ef1-e61234cc182e/artifacts/e3uy8r7i_Vada%20Pav.png",
    alt: "Mumbai Special Vada Pav"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_6155f013-7394-403e-8ef1-e61234cc182e/artifacts/dteqjp8r_Chole%20Kulche.jpg",
    alt: "Amritsari Kulcha with Lassi"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_6155f013-7394-403e-8ef1-e61234cc182e/artifacts/fojae072_Amritsari%20Paneer%20Tikka.png",
    alt: "Amritsari Paneer Tikka"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_6155f013-7394-403e-8ef1-e61234cc182e/artifacts/dzzufz1a_Dal%20Makhani%20Combo.png",
    alt: "Dal Makhani Combo"
  }
];

export const features = [
  {
    id: 1,
    title: "100% Vegetarian",
    description: "Pure vegetarian North Indian cuisine prepared with authentic recipes and fresh ingredients"
  },
  {
    id: 2,
    title: "Traditional Tandoor",
    description: "Freshly baked in traditional clay tandoor for authentic smoky flavors"
  },
  {
    id: 3,
    title: "Street Food Specialties",
    description: "Authentic Mumbai and Delhi street food favorites in a hygienic environment"
  },
  {
    id: 4,
    title: "Franchise Opportunities",
    description: "Join the Ambarsariya family and bring authentic North Indian flavors to your city"
  }
];

export const customerReviews = [
  {
    id: 1,
    name: "Priya Sharma",
    rating: 5,
    review: "Amazing food quality! The Chole Bhature was absolutely delicious and authentic. The ambiance at VR Nagpur is great too. Highly recommended for vegetarian food lovers!",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    rating: 5,
    review: "Best North Indian food in Nagpur! The Dal Makhani and Laccha Paratha combination is to die for. Service is prompt and staff is very courteous. Will definitely visit again!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Sneha Patel",
    rating: 5,
    review: "Loved the Tandoori Paneer Tikka and Punjabi Lassi! Everything tasted fresh and flavorful. The street food section is a must-try. Perfect place for family dining.",
    date: "3 weeks ago"
  },
  {
    id: 4,
    name: "Amit Deshmukh",
    rating: 5,
    review: "Excellent vegetarian restaurant! The kulchas are so soft and stuffed generously. Prices are reasonable considering the quality and quantity. VR Nagpur location is very convenient.",
    date: "2 months ago"
  },
  {
    id: 5,
    name: "Kavita Joshi",
    rating: 5,
    review: "The Golgappe and Dahi Mathri Chaat reminded me of Delhi street food! Authentic taste, hygienic preparation, and great service. A must-visit for anyone who loves North Indian cuisine.",
    date: "1 month ago"
  }
];
